export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-color/src/math.js
// module id = ../../../../d3-color/src/math.js
// module chunks = 4